var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onBeforeMount, ref, inject, provide, nextTick } from 'vue';
import { InternalToolsService } from '@/service/InternalToolsService';
import { useNotification } from '@gohighlevel/ghl-ui';
import UpgradeSubscription from './UpgradeSubscription.vue';
import TshirtModal from '@/components/common/TshirtModal.vue';
import { useI18n } from 'vue-i18n';
import SuccessModal from '../SuccessModal.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpgradeModalParent',
    setup(__props) {
        const { t } = useI18n();
        const notification = useNotification();
        const emitter = inject('emitter');
        const source = inject('source');
        const company = inject('company');
        const activePlan = ref();
        const showModal = ref(false);
        const showSuccessModal = ref(false);
        const showTshirtModal = ref(false);
        const successData = ref({
            title: '',
            description: '',
            icon: undefined,
            type: '',
            showTshirtModal: false,
        });
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            yield initializeActivePlan();
        }));
        function initializeActivePlan() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield InternalToolsService.getActivePlan(company.value.id);
                    activePlan.value = response.data;
                    yield nextTick();
                    showModal.value = true;
                }
                catch (error) {
                    notification.error({
                        title: t('common.error'),
                        content: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || error.message,
                        duration: 5000,
                    });
                }
            });
        }
        function handleSuccess(data) {
            emitter.emit('agency-plan-upgrade-succeded', { source });
            successData.value = data;
            showSuccessModal.value = true;
        }
        function closeSuccessModal() {
            showSuccessModal.value = false;
            if (successData.value.showTshirtModal) {
                showTshirtModal.value = true;
            }
        }
        provide('activePlan', activePlan);
        return (_ctx, _cache) => {
            return (activePlan.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(UpgradeSubscription, {
                        "show-modal": showModal.value,
                        "onUpdate:showModal": _cache[0] || (_cache[0] = ($event) => ((showModal).value = $event)),
                        onClose: _cache[1] || (_cache[1] = ($event) => (showModal.value = false)),
                        onSuccess: handleSuccess
                    }, null, 8 /* PROPS */, ["show-modal"]),
                    _createVNode(SuccessModal, {
                        "show-modal": showSuccessModal.value,
                        title: successData.value.title,
                        description: successData.value.description,
                        icon: successData.value.icon,
                        type: successData.value.type,
                        onClose: closeSuccessModal
                    }, null, 8 /* PROPS */, ["show-modal", "title", "description", "icon", "type"]),
                    (showTshirtModal.value)
                        ? (_openBlock(), _createBlock(TshirtModal, {
                            key: 0,
                            "show-modal": showTshirtModal.value,
                            "onUpdate:showModal": _cache[2] || (_cache[2] = ($event) => ((showTshirtModal).value = $event))
                        }, null, 8 /* PROPS */, ["show-modal"]))
                        : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true);
        };
    }
});
